import { render, staticRenderFns } from "./PublicContent.vue?vue&type=template&id=084052a2&"
import script from "./PublicContent.vue?vue&type=script&lang=js&"
export * from "./PublicContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports